import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';
import StatisticsTabs from '../../../../components/Statistics/StatisticsTabs';
import StatisticsTable from '../../../../components/Statistics/StatisticsTable';
import StatisticsFilters from '../../../../components/Statistics/StatisticsFilters/StatisticsFilters';
import StatisticsSubSections from '../../../../components/Statistics/StatisticsSubSections';
import StatisticsCurrenciesControl from '../../../../components/Statistics/StatisticsCurrenciesControl';
import StatisticsConversionsTable from '../../../../components/Statistics/StatisticsConversionsTable/StatisticsConversionsTable';
import StatisticsGoalsTable from '../../../../components/Statistics/StatisticsGoalsTable';
import StatisticsTableChart from '../../../../components/Statistics/StatisticsTableChart';
import Pagination from '../../../../components/Pagination/Pagination';
import StatisticsControls from '../../../../components/Statistics/StatisticsControls';
import { isMaster } from '../../../../components/Statistics/statisticsHelpers';
import { CSSTransition } from 'react-transition-group';
import { FMessage } from '../../../../hoc/IntlComponents';
import { parse } from 'query-string';
import StatisticsShare from '@components/Statistics/StatisticsShare';
import StatisticsPagerSettings from '../../../../components/Statistics/StatisticsPagerSettings';

const View = ({
  data: {
    tabs,
    config,
    currencies,
    hideFilters,
    isMembers,
    isMember,
    className,
    tab,
    loading,
    type,
    stats,
    total,
    page,
    limit,
    pageCount,
    isMounted,
    startCreateWebmasterPreset,
    startUpdateWebmasterPreset,
    startRemoveWebmasterPreset,
    showAlert,
    currency,
    isPagination,
    isChart,
    isSharing,
    requestParams,
    theme,
  },
  cardHeaderRef,
  handleTabChange,
  handleRefresh,
  handleSectionChange,
  changeCurrency,
  setPagesCount,
  handleDeleteSlave,
  handlePageChange,
  handleFilterUpdate,
  onSettingsUpdate,
  setSharingState,
}) => {
  const subsTab = tabs.find(({ id }) => id === 'subs');
  const devicesTab = tabs.find(({ id }) => id === 'devices');

  const [showSubs, toggleSubs] = useState(false);

  const [showDevices, toggleDevices] = useState(false);

  const currentType = parse(window.location.search).type;

  useEffect(() => {
    tab.id === 'subs' ? toggleSubs(true) : toggleSubs(false);
    tab.id === 'devices' ? toggleDevices(true) : toggleDevices(false);
  }, [tab]);

  const handleClick = () => {
    !showSubs && toggleSubs(true);
  };
  const handleDevicesClick = () => {
    !showDevices && toggleDevices(true);
  };

  const [firstRow, secondRow] = (() => {
    if (tabs && tabs.length > 0) {
      let spreadedTabs = [
        ...tabs.find(tab => tab.id === 'times').tabs,
        ...tabs.find(tab => tab.id === 'landings').tabs,
        ...tabs.filter(tab => tab.id !== 'times' && tab.id !== 'landings'),
      ];

      const reorderedTabs = spreadedTabs.map(tab => {
        switch (tab.id) {
          case 'times':
            tab.placement = { row: 1, order: 1 };
            return tab;
          case 'hourly':
            tab.placement = { row: 1, order: 2 };
            return tab;
          case 'landings':
            tab.placement = { row: 1, order: 3 };
            return tab;
          case 'transits':
            tab.placement = { row: 1, order: 4 };
            return tab;
          case 'offers':
            tab.placement = { row: 1, order: 5 };
            return tab;
          case 'countries':
            tab.placement = { row: 1, order: 6 };
            return tab;
          case 'subs':
            tab.placement = { row: 1, order: 7 };
            return tab;
          case 'pixels':
            tab.placement = { row: 2, order: 1 };
            return tab;
          case 'flows':
            tab.placement = { row: 2, order: 2 };
            return tab;
          case 'sources':
            tab.placement = { row: 2, order: 3 };
            return tab;
          case 'leads':
            tab.placement = { row: 2, order: 4 };
            return tab;
          case 'devices':
            tab.placement = { row: 2, order: 5 };
            return tab;

          default:
            return tab;
        }
      });

      const firstRow = reorderedTabs
        .filter(({ placement }) => placement.row === 1)
        .sort((a, b) => {
          return a.placement.order - b.placement.order;
        });
      const secondRow = reorderedTabs
        .filter(({ placement }) => placement.row === 2)
        .sort((a, b) => {
          return a.placement.order - b.placement.order;
        });
      return [firstRow, secondRow];
    } else return [[], []];
  })();
  return (
    <Fragment>
      <h3 className="mobile-title">
        <FormattedMessage id="pages.statistics.title" defaultMessage="Statistics" />
      </h3>
      {/* Statistics Tabs */}
      <Card className="statistics-tabs">
        <Card.Body>
          {tabs.length > 0 && !hideFilters && (
            <>
              <h6 className="mb-0 mr-auto">
                <FMessage
                  id={`statistics.tabs.stat-by.${
                    currentType && currentType.startsWith('subs')
                      ? 'subs'
                      : currentType === 'os' || currentType === 'browsers'
                      ? 'devices'
                      : currentType
                  }`}
                />
              </h6>
              <StatisticsTabs
                className="statistics-tabs-list"
                theme={4}
                toggleSubsAnimation={handleClick}
                currentTab={tab}
                allTabs={[...firstRow, ...secondRow]}
                tabs={firstRow}
                type={type}
                onTabChange={handleTabChange}
              />
              <CSSTransition in={showSubs} timeout={1000} unmountOnExit classNames="subIds-section">
                <StatisticsSubSections type={type} onChange={handleSectionChange} {...subsTab} />
              </CSSTransition>
            </>
          )}
        </Card.Body>
        <Card.Body className="secondRow">
          {tabs.length > 0 && !hideFilters && (
            <>
              <StatisticsTabs
                className="statistics-tabs-list"
                theme={4}
                toggleSubsAnimation={handleDevicesClick}
                currentTab={tab}
                tabs={secondRow}
                type={type}
                onTabChange={handleTabChange}
              />
              <CSSTransition
                in={showDevices}
                unmountOnExit
                timeout={1000}
                classNames="subIds-section"
              >
                <StatisticsSubSections type={type} onChange={handleSectionChange} {...devicesTab} />
              </CSSTransition>
            </>
          )}
        </Card.Body>
      </Card>
      <Card className={`statistics ${className ? className : ''}`} loading={loading}>
        <Card.Header className="hide-on-xl no-padding">
          <StatisticsTabs
            className="statistics-tabs-list"
            theme={4}
            toggleSubsAnimation={handleClick}
            currentTab={tab}
            allTabs={[...firstRow, ...secondRow]}
            tabs={firstRow}
            type={type}
            onTabChange={handleTabChange}
          />
        </Card.Header>
        {/* Statistics Filters */}
        <Card.Body>
          {!hideFilters && (
            <Row>
              <Col>
                <StatisticsFilters
                  onCreatePreset={startCreateWebmasterPreset}
                  onSavePreset={startUpdateWebmasterPreset}
                  onRemovePreset={startRemoveWebmasterPreset}
                  onFilterUpdate={handleFilterUpdate}
                  onSettingsUpdate={onSettingsUpdate}
                  onRefresh={handleRefresh}
                  showAlert={showAlert}
                  active={currency}
                  currencies={currencies}
                  onCurrencyChange={changeCurrency}
                  tab={tab}
                  handleSectionChange={handleSectionChange}
                  stats={stats}
                  total={total}
                  type={type}
                  currency={currency}
                  isMember={isMember}
                  isMembers={isMembers}
                />
              </Col>
              {/* <Col lg="4" /> */}
            </Row>
          )}
          <Row className="statistic-sub-section-container justify-content-between">
            <Col sm="5" md="5" lg="7">
              {!hideFilters && tab.id && tab.tabs && (
                <StatisticsSubSections
                  className="hide-on-xl"
                  type={type}
                  onChange={handleSectionChange}
                  {...tab}
                />
              )}
            </Col>

            {currencies && currencies.length > 1 && (
              <Col
                xs="12"
                lg="5"
                md="7"
                sm="7"
                className="text-right statistics-subsection-controls"
              >
                <StatisticsCurrenciesControl
                  active={currency}
                  currencies={currencies}
                  onCurrencyChange={changeCurrency}
                />
              </Col>
            )}
          </Row>
        </Card.Body>

        {/* Statistics Table */}
        <Card.Body className="table-container">
          {isChart && !isMaster && (type === 'times' || type === 'hourly') && (
            <StatisticsTableChart stats={stats} currency={currency} type={type} total={total} />
          )}

          {type === 'leads' && (
            <StatisticsConversionsTable
              config={config}
              currency={currency}
              stats={stats}
              page={page}
              limit={limit}
              setPagesCount={setPagesCount}
              loading={loading}
              isMounted={isMounted}
              isMember={isMember}
              isPagination={isPagination}
            />
          )}
          {type === 'pixels' && (
            <StatisticsGoalsTable
              config={config}
              currency={currency}
              stats={stats}
              total={total}
              limit={limit}
              page={page}
              setPagesCount={setPagesCount}
              tab={type}
              loading={loading}
              isMounted={isMounted}
              isMember={isMember}
            />
          )}

          {type !== 'leads' && type !== 'pixels' && (
            <StatisticsTable
              config={config}
              currency={currency}
              stats={stats}
              total={total}
              page={page}
              limit={limit}
              setPagesCount={setPagesCount}
              tab={type}
              loading={loading}
              isMembers={isMembers}
              handleDeleteSlave={handleDeleteSlave}
              isMounted={isMounted}
              isMember={isMember}
              isPagination={isPagination}
            />
          )}
        </Card.Body>

        {/* Statistics Pages */}
        {!loading && (
          <Card.Footer>
            {pageCount > 1 && (
              <Pagination
                affectUrl
                pageCount={pageCount}
                onPageChange={handlePageChange}
                activePage={page + 1}
                scrollToAfterPageChanged={{ ref: cardHeaderRef.current }}
              />
            )}

            <StatisticsPagerSettings limit={limit} onSettingsUpdate={onSettingsUpdate} />

            {!isMember && (
              <StatisticsShare
                isLoading={isSharing}
                setSharingState={setSharingState}
                showAlert={showAlert}
                requestParams={requestParams}
                theme={theme}
              />
            )}
          </Card.Footer>
        )}
      </Card>
    </Fragment>
  );
};

export default View;
